import axios from 'axios';
import { stringify } from 'qs';

const toSnakeCase = (str: string): string => {
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

const convertKeysToSnakeCase = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(convertKeysToSnakeCase);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: Record<string, any>, key) => {
            acc[toSnakeCase(key)] = convertKeysToSnakeCase(obj[key]);
            return acc;
        }, {} as Record<string, any>);
    }
    return obj;
}

const toCamelCase = (str: string) => {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

const convertKeysToCamelCase = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(convertKeysToCamelCase);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: Record<string, any>, key) => {
            acc[toCamelCase(key)] = convertKeysToCamelCase(obj[key]);
            return acc;
        }, {} as Record<string, any>);
    }
    return obj;
}


const publicUrl = process.env.REACT_APP_API_URL + '/v1';
export const PAYLATER_API_URL = publicUrl;

export const axiosAvmApi = axios.create({
    baseURL: PAYLATER_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Api-Key': process.env.REACT_APP_API_KEY,
    },
    withCredentials: true,
    paramsSerializer: (params) => {
        return stringify(params, {
            allowDots: true,
            skipNulls: true,
        });
    },
});

axiosAvmApi.interceptors.request.use(
    (config) => {
        if (config.data) {
            config.data = convertKeysToSnakeCase(config.data);
        }
        if (config.params) {
            config.params = convertKeysToSnakeCase(config.params);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosAvmApi.interceptors.response.use(
    (response) => {
        if (response.data) {
            response.data = convertKeysToCamelCase(response.data);
        }
        return response;
    },
    (error) => Promise.reject(error)
);
